import { TFunction } from 'i18next';

import {
  EMAIL_LABEL,
  EMAIL_PLACEHOLDER,
  ENTER_MEMBER_ID_TRANSLATION,
  FIRST_NAME_LABEL,
  FIRST_NAME_PLACEHOLDER,
  LAST_NAME_LABEL,
  LAST_NAME_PLACEHOLDER,
  MEMBER_ID_TRANSLATION,
  SEARCH_FOR_MEMBER_BTN,
} from '@domain/clubs';

export const getClubsTranslation: (t: TFunction, value: string) => string = (
  t: TFunction,
  value: string
) => {
  switch (value) {
    case EMAIL_LABEL:
      return t('add-member.identify-member-form.email', 'Email');

    case EMAIL_PLACEHOLDER:
      return t(
        'add-member.identify-member-form.email.placeholder',
        'Enter Email'
      );

    case MEMBER_ID_TRANSLATION:
      return t('add-member.identify-member-form.member-id', 'Member ID');

    case ENTER_MEMBER_ID_TRANSLATION:
      return t(
        'mml.identify-member-form-placeholder.member-id',
        'Enter member ID'
      );

    case FIRST_NAME_LABEL:
      return t('signup.form.firstname-label', 'First Name');

    case FIRST_NAME_PLACEHOLDER:
      return t(
        'add-member.identify-member-form.first-name.placeholder',
        'Enter First Name'
      );

    case LAST_NAME_LABEL:
      return t('signup.form.lastname-label', 'Last Name');

    case LAST_NAME_PLACEHOLDER:
      return t(
        'add-member.identify-member-form.last-name.placeholder',
        'Enter Last Name'
      );

    case SEARCH_FOR_MEMBER_BTN:
      return t(
        'add-member.identify-member-form.search-member-button',
        'Search'
      );

    default:
      return '';
  }
};
